import { tokensToCss } from "@el/tokens";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { ToastProvider } from "./components/toast";
import { AuthProvider } from "./lib/auth";
import { reportError } from "./lib/errors";
import "./styles/app.css";
import "./styles/editor.css";

// 色・大きさの CSS 変数は @el/tokens からだけ作る
const style = document.createElement("style");
style.id = "el-tokens";
style.textContent = tokensToCss();
document.head.prepend(style);

// 端末の保存領域を消されにくくする（オフラインで作った提案を守る）
void navigator.storage?.persist?.().catch(() => undefined);

window.addEventListener("unhandledrejection", (e) => reportError(e.reason, { kind: "unhandledrejection" }));

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>,
);
